"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isISHISession = exports.isIWHISession = exports.isARHISession = exports.isGUSession = void 0;
const common_1 = require("./common");
/**
 * Type guard for GU Session
 *
 * @param session BaseSession
 * @returns true if GU Session or if the session is yet to establish speciality (fundId set). false otherwise.
 */
const isGUSession = session => {
  return session.joinSource ? session.joinSource == 'GUWeb' : false;
};
exports.isGUSession = isGUSession;
/**
 * Type guard for Session
 *
 * @param session BaseSession
 * @returns true if ARHI Session or if the session is yet to establish speciality (fundId set). false otherwise.
 */
const isARHISession = session => {
  return session.fundId ? common_1.ArhiFundIds.includes(session.fundId) : true;
};
exports.isARHISession = isARHISession;
/**
 * Type guard for IWHISession
 *
 * @param session BaseSession
 * @returns true if IWHI Session or if the session is yet to establish speciality (fundId set). false otherwise.
 */
const isIWHISession = session => {
  return session.fundId ? session.fundId == common_1.FundToId.IWHI : true;
};
exports.isIWHISession = isIWHISession;
/**
 * Type guard for ISHISession
 *
 * @param session BaseSession
 * @returns true if ISHI Session or if the session is yet to establish speciality (fundId set). false otherwise.
 */
const isISHISession = session => {
  return session.fundId ? session.fundId == common_1.FundToId.ISHI : true;
};
exports.isISHISession = isISHISession;